export default "__VITE_ASSET__DyNsH70s__"